import { getDocument } from '@atlaskit/browser-apis';
import { EVENT_ID, type MessageEventDetails } from '../constants.tsx';

export const emitMessageEvent = (eventDetails: MessageEventDetails): void => {
	const event = new CustomEvent(EVENT_ID, {
		detail: eventDetails,
	});

	getDocument()?.dispatchEvent(event);
};
